<vi-card *ngIf="owner">
  <!-- Owner -->
  <h5 title data-at-inv-header class="header-label">
    {{
      'INVITATIONS.INVITATIONS.COMMERCIAL_INVITATION_HEADER_NO_DEVICE_DETAILS'
        | translate
          : {
              nameAndSurname: owner.firstName + ' ' + owner.lastName
            }
    }}
  </h5>
  <div
    body
    class="invitation-wrapper"
    *ngIf="
      (invitationStatus$ | async) !== InvitationStatusType.Accepted;
      else acceptedCommercialInvitation
    "
  >
    <div class="row-data">
      <span class="label">
        {{ '+INVITATIONS.INVITATIONS.OWNER' | translate }}
      </span>
      <span class="value"> {{ owner.firstName }} {{ owner.lastName }} </span>
    </div>
    <!-- Address -->
    <div class="row-data">
      <span class="label">
        {{ '+INVITATIONS.INVITATIONS.INSTALLATION_ADDRESS' | translate }}
      </span>
      <span class="value">
        {{ owner.street }}
        {{ owner.houseNumber }},
        {{ owner.zip }}
        {{ owner.city }}
      </span>
    </div>
    <!-- Phone number -->
    <div class="row-data">
      <span class="label">
        {{ '+INVITATIONS.INVITATIONS.PHONE_NUMBER' | translate }}
      </span>
      <span class="value"> {{ owner.phoneNumber | formatPhoneNumber }}</span>
    </div>
    <!-- Status -->
    <div class="row-data">
      <span class="label">
        {{ '+INVITATIONS.INVITATIONS.STATUS' | translate }}
      </span>
      <span class="value">
        {{ '+INVITATIONS.INVITATIONS.PENDING' | translate }}
        {{ invitation.tokenExpirationDate | remaining }}
      </span>
    </div>
    <!-- Note -->
    <div class="note">
      <span class="label">
        {{ '+INVITATIONS.INVITATIONS.NOTE' | translate }}
      </span>
      <span class="value">
        {{owner.note ?? NO_VALUE}}
      </span>
    </div>

    <div class="buttons">
      <button
        data-at-inv-cancel
        mat-button
        color="primary"
        gtm="onOpen"
        gtmAction="Cancel commercial invitation"
        gtmCategory="invitation"
        (click)="declineInvitation()"
      >
        {{ '+INVITATIONS.INVITATIONS.DECLINE' | translate }}
      </button>
      <button
        data-at-inv-accept
        mat-stroked-button
        color="primary"
        gtm="onOpen"
        gtmAction="Confirm commercial invitation"
        gtmCategory="invitation"
        (click)="confirmInvitation()"
      >
        {{ '+INVITATIONS.INVITATIONS.CONFIRM' | translate }}
      </button>
    </div>
  </div>

  <!-- After confirmation -->
  <ng-template #acceptedCommercialInvitation>
    <div body class="invitation-wrapper">
      <div class="success-message">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h5 class="header-label">
          {{ '+INVITATIONS.INVITATIONS.COMMERCIAL_ACCEPTED' | translate }}
        </h5>
      </div>

      <div class="buttons">
        <button
          data-at-inv-cancel
          mat-button
          color="primary"
          gtm="onGoToPage"
          gtmAction="Go to all installations"
          gtmCategory="installations"
          routerLink="/installations"
        >
          {{ '+INVITATIONS.INVITATIONS.ALL_DEVICES' | translate }}
        </button>
        <button
          data-at-inv-accept
          mat-stroked-button
          color="primary"
          gtm="onGoToPage"
          gtmAction="Go to installation details"
          gtmCategory="installations"
          [routerLink]="['/installations/', invitation.installationId]"
        >
          {{ '+INVITATIONS.INVITATIONS.GO_TO_DEVICE' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</vi-card>
